const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
export const types = {
  SET_ORION_INFO: "CLIENT_PERSONALIZATION/SET_ORION_INFO",

  INIT_PERSONALIZATION: "CLIENT_PERSONALIZATION/INIT_PERSONALIZATION",
  INIT_PERSONALIZATION_SUCCESS:
    "CLIENT_PERSONALIZATION/INIT_PERSONALIZATION_SUCCESS",

  UPDATE_PERSONALIZATION: "CLIENT_PERSONALIZATION/UPDATE_PERSONALIZATION",
  UPDATE_PERSONALIZATION_SUCCESS:
    "CLIENT_PERSONALIZATION/UPDATE_PERSONALIZATION_SUCCESS",
};

export const actions = {
  setOrionInfo: (data) => ({
    type: types.SET_ORION_INFO,
    payload: { data },
  }),
  initPersonalization: (data) => ({
    type: types.INIT_PERSONALIZATION,
    payload: { data },
  }),
  initPersonalizationSuccess: (data) => ({
    type: types.INIT_PERSONALIZATION_SUCCESS,
    payload: data,
  }),
  updatePersonalization: (data) => ({
    type: types.UPDATE_PERSONALIZATION,
    payload: { data },
  }),
  updatePersonalizationSuccess: (data) => ({
    type: types.UPDATE_PERSONALIZATION_SUCCESS,
    payload: data,
  }),
};

const initialState = {
  finalOrionInfo: null,
  loadingOrionInfo: false,
  activePersonalizationKey: null,
  appliedPersonalizationKey: null,
  orionLMCInfo: null,
  orionLMAInfo: null,
  compatibility: {
    isCompatible: true,
    incompatibilityType: null,
  },
  pills: null,
  title: null,
};

/* eslint-disable default-param-last */
function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case HYDRATE: {
      let { clientPersonalization } = action.payload;
      return {
        ...state,
        ...clientPersonalization,
      };
    }
    case types.SET_ORION_INFO: {
      const { kind, orionInfo } = action.payload.data;

      if (kind === "LMC") {
        return {
          ...state,
          orionLMCInfo: orionInfo,
        };
      } else if (kind === "LMA") {
        return {
          ...state,
          orionLMAInfo: orionInfo,
        };
      }

      return {
        ...state,
      };
    }
    case types.INIT_PERSONALIZATION: {
      const { personalizationKey = null } = action.payload?.data || {};
      return {
        ...state,
        finalOrionInfo: null,
        loadingOrionInfo: true,
        activePersonalizationKey: personalizationKey,
        appliedPersonalizationKey: null,
      };
    }
    case types.INIT_PERSONALIZATION_SUCCESS: {
      const {
        response,
        mobileLinesNumbers,
        pills,
        title,
        compatibility,
        personalizationKey,
      } = { ...action.payload };
      const { finalOrionInfo } = { ...response };
      return {
        ...state,
        finalOrionInfo,
        mobileLinesNumbers,
        loadingOrionInfo: false,
        activePersonalizationKey: null,
        appliedPersonalizationKey:
          personalizationKey || state.activePersonalizationKey,
        pills,
        title,
        compatibility,
      };
    }
    case types.UPDATE_PERSONALIZATION: {
      return {
        ...state,
        finalOrionInfo: null,
        loadingOrionInfo: true,
      };
    }
    case types.UPDATE_PERSONALIZATION_SUCCESS: {
      const { response, mobileLinesNumbers, compatibility } = {
        ...action.payload,
      };
      const { finalOrionInfo } = { ...response };
      return {
        ...state,
        finalOrionInfo,
        mobileLinesNumbers,
        loadingOrionInfo: false,
        compatibility,
      };
    }
    default:
      return state;
  }
}

export default reducer;
